import PropTypes from 'prop-types';
import cn from 'classnames';
import {statusIcons} from '../../../../assets/svg';

import './cocResultIndicator.scss';

const resultsMap = {
  pass: {
    Icon: statusIcons.statusPass,
    label: 'PASS',
  },
  fail: {
    Icon: statusIcons.statusFail,
    label: 'FAIL',
  },
};


export default function CoCResultIndicator ({
                                              result = ''
                                            }) {
  const data = resultsMap[result] || {};
  const { Icon, label } = data;

  return (
    <div className={cn('coc-result-indicator', result)}>
      {Icon && <Icon className='coc-result-indicator__icon'/>}
      {label && <span>{label}</span>}
    </div>
  )
}

CoCResultIndicator.propTypes = {
  result: PropTypes.oneOf(['pass', 'fail']),
}
